/* eslint-disable max-len */
import iconPin from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/pin-container.png';
export default iconPin;
